import React from 'react';
import { useNavigate } from 'react-router-dom';
import './FreeSiteBanner.css';

export default function FreeSiteBanner() {
  const navigate = useNavigate();

  return (
    <div className="free-site-banner">
      <div className="free-site-banner-text">
        <span className="free-site-banner-tag">Limited Time</span>
        <span>
          We're giving back to our community, <strong>we'll build your website completely free.</strong>
        </span>
      </div>
      <button className="free-site-banner-btn" onClick={() => navigate('/apply')}>
        Claim Your Free Website →
      </button>
    </div>
  );
}
